import { useQuery } from '@tanstack/react-query'

import { IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import { useAwardExistenceLoader } from '@/services/award-existence-loader/context'

import { usaspendingKeys } from './queryKeys'

export interface UseAwardExistenceCheckOptions {
  awardId: string
  enabled?: boolean
}

export const useAwardExistenceCheck = ({
  awardId,
  enabled = true,
}: UseAwardExistenceCheckOptions) => {
  const loader = useAwardExistenceLoader()

  return useQuery({
    queryKey: usaspendingKeys.awardExists(awardId),
    queryFn: () => loader!.load(awardId),
    enabled: !IS_FEDRAMP_ENVIRONMENT && !!loader && enabled,
    staleTime: Infinity, // Never consider stale
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
